import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseClient } from 'builder/modules/apiClient'
import { RecommendAlert } from 'builder/modules/jobSearch/types'
import { transformerRecommendAlert } from './utils'

interface MutationParams {
  data: Partial<RecommendAlert>
  shouldUpdateCache?: boolean
}

export const useMutationRecommendationAlert = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async (params: MutationParams): Promise<RecommendAlert> => {
      const res = await baseClient.put('/job-alerts/v1/recommendation-subscription', params.data)
      return transformerRecommendAlert(res.data)
    },
    {
      onSuccess: (data, variables) => {
        if (variables.shouldUpdateCache) {
          queryClient.setQueryData<RecommendAlert>(['useGetRecommendationAlert'], () => {
            return data
          })
        }
      },
    },
  )
}
